import loginPrompt from './loginPrompt';
import abandonCheckout from './abandonCheckout/index';
import { tradePromosConfig } from './tradePromos/tradePromosConfig';
import { tradeGeneralOnboardingConfig } from './tradeGeneralOnboarding/tradeGeneralOnboardingConfig';
import { privacyPolicyChangeNoticeConfig } from './privacyPolicyChangeNotice/privacyPolicyChangeNoticeConfig';
import tradeRewardsLevelUp from './tradeRewardsLevelUp';
import { tradeVerifyFirmReminderConfig } from './tradeVerifyFirmReminder/tradeVerifyFirmReminderConfig';
import { tradeRewardsEndOfYearMessagingConfig } from './tradeRewardsEndOfYearMessaging/tradeRewardsEndOfYearMessagingConfig';
import tradeWindfallReferral from './tradeWindfallReferral';
import loggedOutTrade from './loggedOutTrade';
import vipCuratedFolder from './vipCuratedFolder';
import { tradeEnrollmentAndStatusUpdateConfig } from './tradeEnrollmentAndStatusUpdate/tradeEnrollmentAndStatusUpdateConfig';

export default [
    ...abandonCheckout,
    loginPrompt,
    privacyPolicyChangeNoticeConfig,
    tradeGeneralOnboardingConfig,
    tradeRewardsEndOfYearMessagingConfig,
    ...tradePromosConfig,
    tradeRewardsLevelUp,
    tradeVerifyFirmReminderConfig,
    tradeWindfallReferral,
    loggedOutTrade,
    vipCuratedFolder,
    tradeEnrollmentAndStatusUpdateConfig,
];
